"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_is_1 = require("react-is");
var menu_list_1 = __importDefault(require("@prezzee/menu-list"));
var paper_1 = __importDefault(require("@prezzee/paper"));
var popover_1 = __importDefault(require("@prezzee/popover"));
var theme_1 = require("@prezzee/theme");
var style = __importStar(require("./Menu.style"));
var RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right',
};
var LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left',
};
var Menu = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.autoFocus, autoFocus = _a === void 0 ? true : _a, children = props.children, _b = props.disableAutoFocusItem, disableAutoFocusItem = _b === void 0 ? false : _b, _c = props.MenuListProps, MenuListProps = _c === void 0 ? {} : _c, onClose = props.onClose, open = props.open, 
    // @ts-ignore
    _d = props.PaperProps, 
    // @ts-ignore
    PaperProps = _d === void 0 ? {} : _d, 
    // PopoverClasses,
    _e = props.transitionDuration, 
    // PopoverClasses,
    transitionDuration = _e === void 0 ? 'auto' : _e, _f = props.TransitionProps, _g = _f === void 0 ? {} : _f, onEntering = _g.onEntering, TransitionProps = __rest(_g, ["onEntering"]), _h = props.variant, variant = _h === void 0 ? 'selectedMenu' : _h, other = __rest(props, ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "transitionDuration", "TransitionProps", "variant"]);
    var theme = (0, theme_1.useTheme)();
    // const isRtl = theme.direction === 'rtl';
    var isRtl = false;
    // const ownerState = {
    //   ...props,
    //   autoFocus,
    //   disableAutoFocusItem,
    //   MenuListProps,
    //   onEntering,
    //   PaperProps,
    //   transitionDuration,
    //   TransitionProps,
    //   variant,
    // };
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = (0, react_1.useRef)(null);
    var handleEntering = function (element, isAppearing) {
        if (menuListActionsRef.current) {
            // @ts-ignore
            menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        }
        if (onEntering) {
            onEntering(element, isAppearing);
        }
    };
    var handleListKeyDown = function (event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) {
                // @ts-ignore
                onClose(event, 'tabKeyDown');
            }
        }
    };
    /**
     * the index of the item should receive focus
     * in a `variant="selectedMenu"` it's the first `selected` item
     * otherwise it's the very first item.
     */
    var activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    react_1.Children.map(children, function (child, index) {
        if (!(0, react_1.isValidElement)(child)) {
            return;
        }
        if (process.env.NODE_ENV !== 'production') {
            if ((0, react_is_1.isFragment)(child)) {
                console.error([
                    "The Menu component doesn't accept a Fragment as a child.",
                    'Consider providing an array instead.',
                ].join('\n'));
            }
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) {
                activeItemIndex = index;
            }
            else if (activeItemIndex === -1) {
                activeItemIndex = index;
            }
        }
    });
    return ((0, jsx_runtime_1.jsx)(popover_1.default
    // classes={PopoverClasses}
    , __assign({ 
        // classes={PopoverClasses}
        onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left',
        }, 
        // @ts-ignore
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN, PaperProps: __assign(__assign({ component: paper_1.default }, PaperProps), { css: style.paper }), 
        // className={classes.root}
        open: open, ref: ref, transitionDuration: transitionDuration, TransitionProps: __assign({ onEntering: handleEntering }, TransitionProps) }, other, { children: (0, jsx_runtime_1.jsx)(menu_list_1.default, __assign({ onKeyDown: handleListKeyDown, 
            // @ts-ignore
            actions: menuListActionsRef, autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem), autoFocusItem: autoFocusItem, variant: variant }, MenuListProps, { children: children })) })));
});
exports.default = Menu;
//# sourceMappingURL=Menu.js.map